import { Action } from 'redux';

import {
  ServerUserDelete,
  ServerUserEditSiteMembership, ServerUserForcePasswordUpdate,
  ServerUserResetLoginRateLimiting
} from '../../../bootstrap/redux/actions/AppActionTypes';
import { IServerUserInfo } from '../models/IServerUserInfo';

export interface ServerUserMenuAction extends Action {
  items: IServerUserInfo[];
}

export function serverUserDelete(items: IServerUserInfo[]): ServerUserMenuAction {
  return {
    type: ServerUserDelete,
    items
  };
}

export function serverUserEditSiteMembership(items: IServerUserInfo[]): ServerUserMenuAction {
  return {
    type: ServerUserEditSiteMembership,
    items
  };
}

export function serverUserForcePasswordUpdate(items: IServerUserInfo[]): ServerUserMenuAction {
  return {
    type: ServerUserForcePasswordUpdate,
    items
  };
}

export function serverUserResetLoginRateLimiting(items: IServerUserInfo[]): ServerUserMenuAction {
  return {
    type: ServerUserResetLoginRateLimiting,
    items
  };
}
